/**
 * Authorization Roles
 */
const authRoles = {
	productOwner: ['product_owner'],
};

export default authRoles;
